import React, { useState } from "react";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import apiService from "../services/apiService";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const NewChapter = () => {
  const navigate = useNavigate();
  const [chapter, setChapter] = useState({
    description: "",
    content_id: "",
    title: "",
    chapter_title: "",
    audio_file: null,
    // chapter_type: "1", // Default to story
    url: "", 
  });
  const [audioUrl, setAudioUrl] = useState(""); // Add state for audio_url

  const [audioPreview, setAudioPreview] = useState(null);
  const [searchResults, setSearchResults] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [audioOption, setAudioOption] = useState("file"); // Track the selected audio option (file or url)
  let searchTimeout = null;

  const handleChange = (e) => {
    const { name, type, files, value } = e.target;
    if (type === "file") {
      const file = files[0];
      setChapter({ ...chapter, [name]: file });
      setAudioPreview(URL.createObjectURL(file));
    } else {
      setChapter({ ...chapter, [name]: value });

      if (name === "title") {
        if (searchTimeout) clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => handleSearch(value), 300);
      }
    }
  };

  const handleSearch = async (query) => {
    if (!query) {
      setSearchResults([]);
      setShowSuggestions(false);
      return;
    }

    try {
      const response = await apiService.postData("admin/search-content", { title: query });
      const data = response.data || [];
      setSearchResults(Array.isArray(data) ? data : []);
      setShowSuggestions(true);
    } catch (error) {
      console.error("Error fetching search results:", error);
      setSearchResults([]);
      setShowSuggestions(false);
    }
  };

  const handleSelectTitle = (title, content_id) => {
    setChapter({ ...chapter, title, content_id });
    setShowSuggestions(false);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!chapter.content_id) {
      toast.error("Please select content before adding a chapter.");
      return;
    }
  
    if (!chapter.chapter_title || !chapter.description || !chapter.duration) {
      toast.error("Please fill all mandatory fields.");
      return;
    }
  
    let payload = {
      content_id: chapter.content_id,
      title: chapter.chapter_title,
      description: chapter.description,
      duration: chapter.duration,
      // chapter_type: chapter.chapter_type,
    };
  
    if (audioOption === "file" && chapter.audio_file) {
      const formData = new FormData();
      formData.append("content_id", payload.content_id);
      formData.append("title", payload.title);
      formData.append("description", payload.description);
      formData.append("duration", payload.duration);
      formData.append("chapter_type", payload.chapter_type);
      formData.append("is_audio_upload", true);
      formData.append("songNumber", chapter.songNumber || ""); 
      formData.append("audio_file", chapter.audio_file);
  
      try {
        const response = await apiService.postData("admin/save-chapter", formData, true);
        if (response && response.error === false) {
          toast.success("Chapter added successfully.");
          navigate("/chapters");
        } else {
          toast.error(response.message || "Something went wrong.");
        }
      } catch (error) {
        console.error(error);
        toast.error("An error occurred while uploading the chapter.");
      }
  
    } else if (audioOption === "url" && audioUrl) {
      payload.is_audio_upload = false;
      payload.audio_file = audioUrl;
  
      try {
        const response = await apiService.postData("admin/save-chapter", payload);
        if (response && response.error === false) {
          toast.success("Chapter added successfully.");
          navigate("/chapters");
        } else {
          toast.error(response.message || "Something went wrong.");
        }
      } catch (error) {
        console.error(error);
        toast.error("An error occurred while uploading the chapter.");
      }
    } else {
      toast.error("Please provide an audio file or audio URL.");
    }
  };
  
  return (
    <div className="row">
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="col-12 col-md-12">
        <div className="card">
          <div className="card-header">
            <h4>New Chapter</h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="form-group position-relative">
                <label>Select Content</label>
                <input
                  type="text"
                  name="title"
                  className="form-control"
                  value={chapter.title}
                  onChange={handleChange}
                  placeholder="Search Content"
                  autoComplete="off"
                />
                {showSuggestions && searchResults.length > 0 && (
                  <div className="list-group position-absolute w-100 mt-1" style={{ zIndex: 10 }}>
                    {searchResults.map((item) => (
                      <button
                        type="button"
                        className="list-group-item list-group-item-action"
                        key={item.content_id}
                        onClick={() => handleSelectTitle(item.title, item.content_id)}
                      >
                        {item.title}
                      </button>
                    ))}
                  </div>
                )}
              </div>
              <div className="form-group mt-3">
                <label>Chapter Title</label>
                <input
                  type="text"
                  name="chapter_title"
                  className="form-control"
                  value={chapter.chapter_title}
                  onChange={handleChange}
                  placeholder="Enter Chapter Title"
                />
              </div>
              <div className="form-group mt-3">
                <label>Description</label>
                <textarea
                  name="description"
                  className="form-control"
                  value={chapter.description}
                  onChange={handleChange}
                  placeholder="Enter Description"
                ></textarea>
              </div>
              {/* <div className="form-group mt-3">
                <label>Song Number</label>
                <input
                  type="text"
                  name="songNumber"
                  className="form-control"
                  value={chapter.songNumber}
                  onChange={handleChange}
                  placeholder="Enter song number"
                />
              </div> */}
              <div className="form-group mt-3">
                <label>Duration</label>
                <input
                  type="text"
                  name="duration"
                  className="form-control"
                  value={chapter.duration}
                  onChange={handleChange}
                  placeholder="Enter duration"
                />
              </div>
              {/* <div className="form-group mt-3">
                <label>Chapter Type</label>
                <div>
                  <label className="me-3">
                    <input
                      type="radio"
                      name="chapter_type"
                      value="1"
                      checked={chapter.chapter_type === "1"}
                      onChange={handleChange}
                    /> Story
                  </label>
                  <label className="me-3">
                    <input
                      type="radio"
                      name="chapter_type"
                      value="2"
                      checked={chapter.chapter_type === "2"}
                      onChange={handleChange}
                    /> Learning
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="chapter_type"
                      value="3"
                      checked={chapter.chapter_type === "3"}
                      onChange={handleChange}
                    /> Song
                  </label>
                </div>
              </div> */}

              {/* Select Audio Option */}
                <div className="form-group mt-3">
                <label>Audio Option</label>
                <div>
                  <label className="me-3">
                    <input
                      type="radio"
                      name="audioOption"
                      value="file"
                      checked={audioOption === "file"}
                      onChange={() => setAudioOption("file")}
                    /> Audio File
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="audioOption"
                      value="url"
                      checked={audioOption === "url"}
                      onChange={() => setAudioOption("url")}
                    /> Audio URL
                  </label>
                </div>
              </div>

              {audioOption === "file" && (
                <div className="form-group mt-3">
                  <label>Audio File</label>
                  <input
                    type="file"
                    name="audio_file"
                    accept="audio/*"
                    className="form-control"
                    onChange={handleChange}
                  />
                </div>
                
              )}
              {audioOption === "file" && (
              <div className="form-group mt-3">
                <label>Song Number</label>
                <input
                  type="text"
                  name="songNumber"
                  className="form-control"
                  value={chapter.songNumber}
                  onChange={handleChange}
                  placeholder="Enter song number"
                />
              </div>
              )}

              {audioOption === "url" && (
                <div className="form-group mt-3">
                  <label htmlFor="audio-url" className="form-label">Enter Audio URL</label>
                  <div className="input-group">
                    <span 
                      className="input-group-text" 
                      id="audio-addon" 
                      style={{ color: '#6c757d', backgroundColor: '#e9ecef' }}
                    >
                      https://playzippy.s3.amazonaws.com/
                    </span>
                    <input
                      type="text"
                      name="audio_url"
                      className="form-control"
                      id="audio-url"
                      value={audioUrl} 
                      onChange={(e) => setAudioUrl(e.target.value)} 
                      placeholder="Enter file name or path"
                      aria-describedby="audio-addon"
                    />
                  </div>
                </div>
              )}

              <div className="d-flex gap-2 mt-4">
                <button type="submit" className="btn btn-primary">
                  <Plus size={16} /> Add Chapter
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => navigate("/chapters")}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewChapter;
